import find from 'lodash/find';
import filter from 'lodash/filter';
import { pathOr } from 'ramda';

export const byId = (state, id) => find(state.settings.taxes, { id });

/**
 * @deprecated Use getEnabledTaxes instead
 */
export const enabled = state => filter(state.settings.taxes, { enabled: true });

export const getEnabledTaxes = enabled;

export const getAllTaxes = pathOr([], ['settings', 'taxes']);
